import MyHeader from '../../Home/MyHeader';
import {ConfigProvider} from 'antd';
import MyFooter from '../../Home/MyFooter';
import img1 from '../../resource/want-hotpot-1.png';
import '../NewsStyles.css';

export default function Index() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            horizontalItemSelectedBg: '#ffffff',
            horizontalItemSelectedColor: '#203864',
            itemColor: '#203864',
            itemPaddingInline: 24,
            activeBarHeight: 0,
          },
          Collapse: {
            contentPadding: 0
          }
        },
      }}
    >
      <MyHeader/>
      <main className="news-room-body">
        <div className="new-room-content">
          <h1>捞王荣获全国首家低嘌呤认证火锅品牌</h1>
          <p className="news-room-date">2025年9月24日</p>
          <img src={img1} alt="Want Hotpot"/>
          <br/>
          <p>
            <strong>火锅低嘌呤 捞王领鲜行</strong><br/>2025年9月24日，捞王在上海博荟店举办发布会，宣布获得“低嘌呤食品”认证，成为全国首家低嘌呤认证火锅品牌——经全球知名检测机构Intertek天祥集团检测，捞王招牌胡椒猪肚鸡汤每100克嘌呤总含量≤50毫克，符合低嘌呤标准。同时捞王全国所有直营门店同步通过“门店每日八小时现熬鲜汤”认证，从食材清洗、汆烫撇沫到慢火煨制的全流程均可追溯。捞王也获得多重营养认证：单份中煲胡椒猪肚鸡含约77.2克蛋白质，约等于23杯牛奶或10个鸡蛋的蛋白质含量，更蕴含钙、钾及胶原蛋白等多重营养，一举打破“健康饮食必失味”的行业认知，让消费者既能尝到粤式火锅的浓醇，又能吃得毫无负担。
          </p>
          <p>
            此外，自9月24日起，捞王在门店手机点单界面增设了菜品分类介绍，方便消费者清晰了解菜品所属类别。目前，捞王超过70%的菜品均由门店自制，火锅的锅底及底汤也全部由全国各门店自行制作，从源头把控新鲜与品质。
          </p>
          <p>
            <strong>15年匠心沉淀：从食材到标准始终守好品质关</strong><br/>自2010年在上海启幕首家门店起，捞王便以“粤式煲汤火锅”为差异化定位——在竟争激烈的火锅市场中开辟出一条独特赛道，以“用好食材，膳待每一位”作为品牌核心和初心。
          </p>
          <p>
            选料上，捞王精选胡椒猪肚鸡的六大核心食材：整只走地三黄鸡、精选猪简骨、严选南风肉再搭配非遗工艺的金华火腿为汤底，幸福猪肚保证脆嫩弹韧，海南原产白胡椒带来辛香回甘，每一种食材都经过捞王层层选，从源头把好品质关。
          </p>
          <p>
            工艺上，捞王首创行业“8小时熬汤标准”，并在全国门店同步执行；店内配备Paragon全店净水系统（搭配3M滤芯）,让熬汤用水直接达到直饮级。如今捞王90%的门店已荣获“餐饮服务食品安全A级门店”称号。
          </p>
          <p>
            凭借这份坚守，捞王收获了多项行业荣誉：连续5年荣登大众点评必吃榜，斩获中饭协“中国10大火锅品牌”等超100项荣誉，亦被弗若斯特沙利文认证为“粤式火锅第一品牌”。
          </p>
          <p>
            <strong>未来布局：把粤式健康火锅送到更多人身边</strong><br/>当下，捞王的健康火锅版图已慢慢扩大，直营门店覆盖全国30+城市，进驻万象城、恒隆广场等线商业体；线上京东、天猫旗舰店，线下Costco、麦德龙等零售渠道。2024年，捞王开启品牌出海计划，把这口鲜美的健康味道，带到了伦敦、东京、纽约等国际城市。
          </p>
          <p>
            未来，捞王将持续以“食在看见、食在新鲜”为品牌经营核心，秉持公开、透明的原则，继续加大健康食品研发投入，积极推广低嘌呤认证成果，推动火锅行业建立现熬汤底的全新标准。在守住传统粤式美味的同时，探索更多健康可能，为每一位消费者提供更安心、健康、美味的餐饮体验。
          </p>
        </div>
      </main>
      <MyFooter/>
    </ConfigProvider>
  );
}